// ©2024 Austin App House. All rights reserved.
import React from 'react';
import {MDBCol, MDBIcon} from 'mdbreact';
import getRatingColor from '../../utils/getRatingColor';

const ContractorRating = ({contractor, iconsSize = '2x', shortInfo = false}) => {
    const commRating = contractor.commRating 
        ? parseInt(contractor.commRating/(contractor.totalJobs +20 )*100)
        : 100;
    const commRatingColor = getRatingColor(commRating);
    const workRating = contractor.workRating
        ? parseInt(contractor.workRating/(contractor.totalJobs +20 )*100)
        : 100;
    const workRatingColor = getRatingColor(workRating);
    const deliverRating = contractor.deliverRating
        ? parseInt(contractor.deliverRating/(contractor.totalJobs +20 )*100)
        : 100;
    const deliverRatingColor = getRatingColor(deliverRating);
    const currentRating = parseInt(contractor.currentRating || 100);
    const currentRatingColor = getRatingColor(currentRating);

    return (
        <div className='flex-box' style={{position: 'relative', width: '100%'}} >
            {
                !shortInfo
                    && <>
                    <div className="card_statuses">
                        <span title='Soft Skills'  className="status_block icon_hammer">{commRating}%</span>
                        <span title='Work' className="status_block icon_briefcase">{workRating}%</span>
                        <span title='Deliverables' className="status_block icon_file">{deliverRating}%</span>
                        <span title='Total Rating' className="status_block">{currentRating}%</span>
                    </div>
                    </>
            }
            
        </div>
    )
}

export default ContractorRating;